import styled from 'styled-components'

export const Divider = styled.hr`
  box-shadow: none;
  border: none;
  height: 1px;
  margin-top: 8px;
  margin-bottom: 8px;
  color: var(--theme-colors-global-grey-grey300);
  background-color: var(--theme-colors-global-grey-grey300);
`

export const BaseItemWrapper = styled.div``
